import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualsService, Individual, CreateInvidualRequest } from '@aslanpay/portal-common-lib';

const useCreateAdmin = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, CreateInvidualRequest>) => {
  return useMutation<Individual, Error, CreateInvidualRequest>(
    ({ email, role, invite, companyId, canTopUpCompanyPoints, salaried }: CreateInvidualRequest) =>
      individualsService.createIndividual({
        email: email.toLowerCase(),
        role,
        invite,
        companyId,
        canTopUpCompanyPoints,
        salaried,
      }),
    { onSuccess, onError }
  );
};

export default useCreateAdmin;
